import React, { useState } from 'react';
import t from 'prop-types';
import Imagen from './imagen';
import Texto from '../../texto/texto';

function ContenidosVisor(_ref) {
  var src = _ref.src,
      srcA = _ref.srcA,
      versionImagen = _ref.versionImagen,
      texto = _ref.texto,
      claseTexto = _ref.claseTexto,
      children = _ref.children;

  var _useState = useState({
    width: 0,
    height: 0
  }),
      imagenTam = _useState[0],
      setImagenTam = _useState[1];

  var textoSinSaltosDeLinea = texto ? texto.replace(/\*/g, ' ') : '';

  function handleLoad(imgRef) {
    var _imgRef$current$getBo = imgRef.current.getBoundingClientRect(),
        width = _imgRef$current$getBo.width,
        height = _imgRef$current$getBo.height;

    setImagenTam({
      width: width,
      height: height
    });
  }

  function handleResize(_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    window.requestAnimationFrame(function () {
      return setImagenTam({
        width: width,
        height: height
      });
    });
  }

  var contenedorChildrenStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: imagenTam.width,
    height: imagenTam.height
  };
  return React.createElement('div', {
    className: 'contenidosVisorImagenes'
  }, React.createElement('div', {
    className: 'imagenVisorImagenes'
  }, React.createElement(Imagen, {
    src: src,
    onLoad: handleLoad,
    onResize: handleResize
  }), versionImagen === 'a' && React.createElement(Imagen, {
    src: srcA
  }), React.createElement('div', {
    className: 'transparencia',
    style: contenedorChildrenStyle
  }, children)), textoSinSaltosDeLinea && React.createElement('div', {
    className: 'zonaTextoVisorImagenes' + claseTexto
  }, React.createElement(Texto, {
    texto: textoSinSaltosDeLinea
  })), !textoSinSaltosDeLinea && React.createElement('div', {
    className: 'zonaTextoVisorImagenes oculto'
  }, React.createElement(Texto, {
    texto: ' '
  })));
}

ContenidosVisor.propTypes = process.env.NODE_ENV !== "production" ? {
  src: t.string,
  srcA: t.string,
  versionImagen: t.oneOf(['', 'a']),
  paso: t.string,
  texto: t.string,
  claseTexto: t.string,
  children: t.any
} : {};
export default ContenidosVisor;